export const ROLE = {
  SELLER: "seller",
  BUYER: "buyer",
};

export const FILTER_TYPE = {
  PROPERTY_TYPE: "propertyType",
  COMMUNITY: "community",
  BEDROOMS: "numberOfBedrooms",
  BATHS: "numberOfBathroom",
  AMENITIES: "keyword",
  STATUS: "handoverStatus",
  DATE: "handoverDate",
};

export const PROMISE_ALL_SETTLED_STATUS = {
  REJECTED_STATUS: "rejected",
  FULFILLED_STATUS: "fulfilled",
};

export const DESTINATION = {
  MOBILE: "mobile",
  EMAIL: "email",
};

export const OTP_INSTANCE = {
  VERIFICATION: "account-verification",
  FORGOT: "forgot-password",
};

export const DEFAULT_BUY_PAYLOAD = {
  noOfBathrooms: [],
  noOfBedrooms: [],
  noOfParking: [],
  noOfGarages: [],
  areaMin: undefined,
  areaMax: undefined,
  priceMin: undefined,
  priceMax: undefined,
  communityIds: [],
  propertyTypeIds: [],
  amenityIds: [],
  tagIds: [],
  areaIds: [],
  buildingIds: [],
};

export const IMAGE_TYPE = {
  image: "images",
  videos: "video",
  thumbnail: "thumbnail",
  other: "image",
};

export const VERIFIED_BY = {
  verifiedByVyom: "VerifiedByVyom",
  managedByVyom: "ManagedByVyom",
  manual: "Manual",
};

export const PAYMENT_STATUS = {
  REJECTED: "failed",
  COMPLETED: "completed",
  PENDING: "pending",
};

export const regex = {
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  passwordStrong:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  passwordMedium:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
  passwordEasy: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
  fullName: /^[a-zA-Z ]*$/,
  numbers1to10: /\b([1-9]|10)\b(\.[1-9]+)/,
  phoneNumber: /^\+|0|00(?:[0-9] ?){6,14}[0-9]$/,
  numbers: /^[0-9]{1,}$/,
};

export const HANDOVER_STATUS = {
  offPlan: "offPlan",
  ready: "ready",
};

export const health_check = {
  code: "ADD-003",
};

export const COOKIE_NAME = {
  token: "websiteToken",
  refreshToken: "websiteRefreshToken",
  userDetails: "userDetails",
  role: "role",
  isLoggedIn: "isLoggedIn",
  profilePicture: "profilePicture",
  cookieConsent: "cookieConsentTaken",
  userId: "userId",
};

export const BAD_WORDS = ["kill", "murder", "suck", "attack"];

export const SALESFORCE_ERROR =
  "error while fetching property images form salesforce";

export const COUNTRY_ARRAY = [
  "United Arab Emirates",
  "India",
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua And Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia And Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, Democratic Republic",
  "Cook Islands",
  "Costa Rica",
  "Cote D'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island & Mcdonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "Indonesia",
  "Iran, Islamic Republic Of",
  "Iraq",
  "Ireland",
  "Isle Of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States Of",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena",
  "Saint Kitts And Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre And Miquelon",
  "Saint Vincent And Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome And Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia And Sandwich Isl.",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard And Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad And Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks And Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Kingdom",
  "United States",
  "United States Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis And Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const MY_PROPERTY_BTN = {
  markForSell: "markForSell",
  editUpgradeWithdraw: "editUpgradeWithdraw",
  viewDetails: "viewDetails",
  editWithdraw: "editWithdraw",
};

export const MAX_FILE_SIZE_LIMIT = {
  RAW_IMAGE: 25,
  COMPRESSED_IMAGE: 5,
  RAW_VIDEO: 50,
};

export const VERIFICATION_STATUS = {
  COMPLETED: "completed",
  IN_COMPLETE: "incomplete",
  UNDER_VERIFICATION: "underVerification",
};

export const SESSION_KEY = {
  ACTIVE_VIEW: "activeView",
};

export const authenticatedRoutes = [
  "/profile",
  "/my-messages",
  "/my-properties",
  "my-favourites",
];
